import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import {
  getNewsletterMaterial,
  globalStatistic,
  getCategoryMaterialItems,
} from "../redux/actions/otherActions";

import PageBanner from "../components/banner/PageBanner";
import PageHelmet from "../components/helmet/PageHelmet";
import { getPageSeo } from "../redux/actions/pageActions";
import { useTranslation } from "react-i18next";

const OzonHubPage = () => {
  const dispatch = useDispatch();
  const [pageSeoData, setPageSeoData] = useState({});
  const { t } = useTranslation("newsletterPage");
  const categoryMaterialItems = useSelector(
    (state) => state.getCategoryMaterialItems.items,
  );

  useEffect(() => {
    dispatch(getPageSeo(1250)).then((res) => {
      if (res) {
        setPageSeoData(res);
      }
    });

    dispatch(getCategoryMaterialItems());
    dispatch(globalStatistic(1250, "PAGE"));
  }, [dispatch]);

  return (
    <>
      {Object.keys(pageSeoData).length !== 0 && (
        <PageHelmet
          title={pageSeoData ? `${pageSeoData.acSeoTitle}` : "Ewe Comp"}
          description={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
          keywords={pageSeoData ? `${pageSeoData.acSeoKeywords}` : ""}
          ogDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
          ogTitle={pageSeoData ? `${pageSeoData.acSeoTitle}` : ""}
          ogUrl={pageSeoData ? `https://ewe.rs/${pageSeoData.acSeoUrl}` : ""}
          ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
          twitterDescription={
            pageSeoData ? `${pageSeoData.acSeoDescription}` : ""
          }
        />
      )}
      <div className="container-content container-main-content newsletter-content top-margin-navbar-escape">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="banner-image-on-top-page">
                <PageBanner categoryType="" categoryId="" pageId="1250" />
              </div>
              <div className="stats-order-content-holder">
                <h1>{t("ozonTitle")}</h1>
              </div>
              <div className="contact-desc" style={{ marginBottom: "30px" }}>
                {t("ozonDesc")}
              </div>
            </div>

            <div className="col-sm-12">
              <div className="row">
                {categoryMaterialItems?.map((item, index) => (
                  <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <Link
                      to={`/ozon-hub/${item.acCategory}`}
                      className="hub-block-link"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        className="img-fluid"
                        src={`https://resource.ewe.rs/media/${item.acCategoryImageLink}`}
                        alt={item.acCategory}
                      />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OzonHubPage;
